import axios from "@/axios";
import Util from "@/util/util";
import moment from "moment";

export const namespaced = true;

const defaultData = {
  id: 0,
  acceptorName: null,
  acceptorUnitOffice: null,
  acceptorOrganizationId: null,
  acceptorSignature: {
    //signatureId: 0,
    type: "TEXT",
    text: null,
    fontFamily: null,
    edit: null,
    view: null,
  },
  acceptorSignatureId: 2,
  acceptorDateRequested: null,
  acceptorDateSigned: null,
  organizations: [],
};

const resetData = {
  type: "TEXT",
  text: null,
  fontFamily: null,
  edit: null,
  view: null,
};

const IMAGE_EXP = /data:image\/[a-z]+;base64,/;

export const state = {
  authorizedAcceptor: Object.assign({}, defaultData),
  helper: {
    countryId: 0,
    buySell: "",
  },
  submitStatus: false,
  authorizeStatus: false,
  authorizedAcceptorErrors: [],
};

export const getters = {
  authorizedAcceptor: (state) => state.authorizedAcceptor,
  authorizedAcceptorSubmitStatus: (state) => state.submitStatus,
  authorizedAcceptorAuthorizeStatus: (state) => state.authorizeStatus,
  authorizedAcceptorHelper: (state) => state.helper,
  authorizedAcceptorErrors: (state) => state.authorizedAcceptorErrors
};

export const mutations = {
  SET_ACCEPTOR_API: (state, response) =>{
    state.authorizedAcceptor = Object.assign({}, state.authorizedAcceptor, response.data, { acceptorSignature: response.data.acceptorSignature ? response.data.acceptorSignature : defaultData.acceptorSignature });

    if (state.authorizedAcceptor.acceptorSignature.edit && !state.authorizedAcceptor.acceptorSignature.edit.match(IMAGE_EXP)) {
      state.authorizedAcceptor.acceptorSignature.edit = window.atob(state.authorizedAcceptor.acceptorSignature.edit)
    }

    if (state.authorizedAcceptor.acceptorSignature.view && !state.authorizedAcceptor.acceptorSignature.view.match(IMAGE_EXP)) {
      state.authorizedAcceptor.acceptorSignature.view = window.atob(state.authorizedAcceptor.acceptorSignature.view)
    }
  },
  SET_ACCEPTOR_SIG: (state, response) => {
    var acceptorSig = Object.assign({}, response.data.acceptorSignature ? response.data.acceptorSignature : defaultData.acceptorSignature);
    acceptorSig.edit = window.atob(acceptorSig.edit);
    acceptorSig.view = window.atob(acceptorSig.view);
    state.authorizedAcceptor.acceptorSignature = acceptorSig;
  },
  SET_ACCEPTOR_DATA: (state, data) => {
    state.authorizedAcceptor = Object.assign({}, state.authorizedAcceptor, data)
  },
  SET_SUBMIT_STATUS: (state, value) => (state.submitStatus = value),
  SET_AUTHORIZE_STATUS: (state, value) => (state.authorizeStatus = value),

  SET_HELPER: (state, value) => (state.helper = value),
  CLEAR_DATA: (state) => (state.authorizedAcceptor = defaultData),
  SET_ERRORS: (state, data) => (state.authorizedAcceptorErrors = data),
  CLEAR_ERRORS: (state) => (state.authorizedAcceptorErrors = [])
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },

  async getAuthorizedAcceptorSubmitStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_SUBMIT_STATUS", false);
    }
    else {
      return await axios.get(`/api/acceptorsignatures/submitstatus/${id}`)
        .then(({ data }) => {
          if (data && data.length === 0) {
            commit("SET_SUBMIT_STATUS", true);
            commit("CLEAR_ERRORS");
          }
          else {
            commit("SET_SUBMIT_STATUS", false);
            commit("SET_ERRORS", data);
          }
        });
    }
  },

  async getAuthorizedAcceptorAuthorizeStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_AUTHORIZE_STATUS", false);
    }
    else {
      return await axios
        .get(`/api/acceptorsignatures/authorizestatus/${id}`)
        .then(({ data }) => {
          if (data && data.length === 0) {
            commit("SET_AUTHORIZE_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
            commit("SET_AUTHORIZE_STATUS", false);
            commit("SET_ERRORS", data);
          }
        });
    }
  },

  async getAuthorizedAcceptorHelper({ commit }, id) {
    if (id == 0) {
      commit("SET_HELPER", { countryId: 0, buySell: "" });
    }
    else {
      return await axios.get("/api/signatures/helper/" + id)
        .then(({ data }) => {
          commit("SET_HELPER", data);
        });
    }
  },

  async getAuthorizedAcceptor({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_ACCEPTOR_API", await axios.get(`/api/acceptorsignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING DELIVERY INFORMATION: ", error); //not handelled
    }
  },
  
  async getAuthorizedAcceptorSignOnly({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_ACCEPTOR_SIG", await axios.get(`/api/acceptorsignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING DELIVERY INFORMATION: ", error); //not handelled
    }
  },

  getCacSignature({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/signatures/certificatename")
        .then(function (response) {
          const cacSignature = "data:image/jpg;base64," + response.data;
          dispatch("setSignature", cacSignature);
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error getting the CAC signature... ${error.response.data}`);
        });
    });
  },

  setSignature({ commit, state }, signature) {
    let date = null;

    // Don't auto-set date for UPLOAD type — backend handles signature dates
    if (!Util.isNullOrEmpty(signature) && signature.type !== "UPLOAD") {
      date = Util.convertToDateTime(moment.utc().format("MM-DD-y HH:mm:ss"));
    }

    commit("SET_ACCEPTOR_DATA", { acceptorSignature: Object.assign({}, state.authorizedAcceptor.acceptorSignature, signature), acceptorDateSigned: date });
  },

  async getOrganizations({ commit, state }, params) {
    try {
      let response = []

      if (params.buySell === "SELL") {

        response = await axios.get("/api/organizations/countrycode/US");

        let organizationId = (response && response.data) ? state.authorizedAcceptor.acceptorOrganizationId : null

        commit("SET_ACCEPTOR_DATA", { organizations: response.data, acceptorOrganizationId: organizationId });
      }

      else if (params.buySell === "BUY" && params.countryId) {

        response = await axios.get(`/api/organizations/countryid/${params.countryId}`);

        let organizationId = (response && response.data) ? state.authorizedAcceptor.acceptorOrganizationId : null

        commit("SET_ACCEPTOR_DATA", { organizations: response.data, acceptorOrganizationId: organizationId });
      }
      
      else if (params.buySell === "BUY" && !params.countryId) {
        // Fallback: Load all organizations if countryId is missing for BUY transactions
        response = await axios.get("/api/organizations");

        let organizationId = (response && response.data) ? state.authorizedAcceptor.acceptorOrganizationId : null

        commit("SET_ACCEPTOR_DATA", { organizations: response.data, acceptorOrganizationId: organizationId });
      }

      let found = response.data.find(item => item.id === state.authorizedAcceptor.acceptorOrganizationId);

      if (params.preOrderDetailStatus && params.agreementInformationStatus && !found) {
        commit("SET_ACCEPTOR_DATA", { acceptorOrganizationId: null });
      }
    }
    catch (error) {
      commit("SET_ACCEPTOR_DATA", { acceptorOrganizationId: null, organizations: [] });
    }
  },

  saveAuthorizedAcceptor({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let acceptor = Object.assign({}, state.authorizedAcceptor, {
        acceptorSignature: (!state.authorizedAcceptor.acceptorSignature.view) ? null :
          {
            ...state.authorizedAcceptor.acceptorSignature,
            edit: (state.authorizedAcceptor.acceptorSignature.edit) ? window.btoa(state.authorizedAcceptor.acceptorSignature.edit) : "",
            view: (state.authorizedAcceptor.acceptorSignature.view) ? window.btoa(state.authorizedAcceptor.acceptorSignature.view) : "",
          },
        acceptorDateSigned: Util.convertToDateTime(state.authorizedAcceptor.acceptorDateSigned),
        pin: (state.authorizedAcceptor.acceptorSignature.view) ? data.pin : null
      });

      axios.post("/api/acceptorsignatures", acceptor, { config: { showToast: false } })
        .then(function (response) {
          return dispatch("getAuthorizedAcceptor", data.orderId);        })
        .then(function () {
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error saving the Authorized Acceptor to the server...  ${error.response.data}`);
        });
    });
  },
};
